const TimeDoesNotBringRelief = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>Time does not bring relief</h2>
            <h4>Edna St. Vincent Millay</h4>
            <p>Time does not bring relief; you all have lied<br/>
            Who told me time would ease me of my pain!<br/>
            I miss him in the weeping of the rain; <br/>
            I want him at the shrinking of the tide;<br/>
            The old snows melt from every mountain-side,<br/>  
            And last year’s leaves are smoke in every lane;<br/>
            But last year’s bitter loving must remain<br/>
            Heaped on my heart, and my old thoughts abide.<br/>   
            There are a hundred places where I fear<br/>
            To go,—so with his memory they brim.<br/>
            And entering with relief some quiet place<br/>   
            Where never fell his foot or shone his face<br/>
            I say, “There is no memory of him here!”<br/>
            And so stand stricken, so remembering him.<br/>
            <br/>
            </p>
        </div>
    )
}
export default TimeDoesNotBringRelief;